// i18next with one namespace per feature (P1-E07). RU is the design's copy, verbatim; UZ is ours
// (Latin by default until PLAN §8 Q1 is answered).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, NAMESPACES, type Locale } from './resources';

export { NAMESPACES, type Locale };
export const LOCALES: Locale[] = ['ru', 'uz'];
export const DEFAULT_LOCALE: Locale = 'ru';
const STORAGE_KEY = 'aiss.locale';

export function storedLocale(): Locale {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'uz' || v === 'ru' ? v : DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

export function rememberLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // private mode: the server copy (users.locale) still holds it
  }
}

void i18n.use(initReactI18next).init({
  resources,
  lng: storedLocale(),
  fallbackLng: DEFAULT_LOCALE,
  ns: [...NAMESPACES],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
});

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
